"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.isDropdownRenderProps = void 0;
var react_1 = __importStar(require("react"));
var Box_1 = require("../Box");
var Button_1 = require("../Button");
var Popper_1 = require("../Popper");
var Caret_1 = require("../Caret");
var Pane_1 = require("../Pane");
var styled_components_1 = __importDefault(require("styled-components"));
var Container = (0, styled_components_1.default)(Box_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  user-select: none;\n"], ["\n  user-select: none;\n"])));
var Mode;
(function (Mode) {
    Mode[Mode["Resting"] = 0] = "Resting";
    Mode[Mode["Active"] = 1] = "Active";
})(Mode || (Mode = {}));
var isDropdownRenderProps = function (children) { return typeof children === "function"; };
exports.isDropdownRenderProps = isDropdownRenderProps;
var Dropdown = function (_a) {
    var label = _a.label, children = _a.children, _b = _a.open, defaultOpen = _b === void 0 ? false : _b, _c = _a.placement, placement = _c === void 0 ? "bottom" : _c, _d = _a.onOpen, onOpen = _d === void 0 ? function () { } : _d, _e = _a.onClose, onClose = _e === void 0 ? function () { } : _e, rest = __rest(_a, ["label", "children", "open", "placement", "onOpen", "onClose"]);
    var _f = __read((0, react_1.useState)(defaultOpen ? Mode.Active : Mode.Resting), 2), mode = _f[0], setMode = _f[1];
    var handleClose = (0, react_1.useCallback)(function () {
        setMode(Mode.Resting);
        onClose();
    }, [onClose]);
    var handleOpen = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        event.stopPropagation();
        setMode(Mode.Active);
        onOpen();
    }, [onOpen]);
    var handleKeydown = (0, react_1.useCallback)(function (_a) {
        var key = _a.key;
        switch (key) {
            case "Escape":
                handleClose();
                break;
            default:
                break;
        }
    }, [handleClose]);
    (0, react_1.useEffect)(function () {
        window.addEventListener("keydown", handleKeydown);
        return function () { return window.removeEventListener("keydown", handleKeydown); };
    }, [handleKeydown]);
    var _g = (0, Popper_1.usePopper)({
        open: mode === Mode.Active,
        placement: placement,
        type: "mousedown",
        onClose: handleClose,
    }), anchorRef = _g.anchorRef, childrenRef = _g.childrenRef, open = _g.open;
    var anchorProps = {
        ref: anchorRef,
        disabled: mode === Mode.Active,
        onMouseDown: handleOpen,
        onClick: handleOpen,
    };
    return (react_1.default.createElement(Container, __assign({}, rest),
        (function () {
            switch (typeof label) {
                case "string":
                    return (react_1.default.createElement(Button_1.Button, __assign({}, anchorProps, { width: "100%", type: "button" }),
                        label,
                        react_1.default.createElement(Caret_1.Caret, { ml: 3, direction: mode === Mode.Active ? "up" : "down" })));
                case "function":
                    return label(__assign(__assign({}, anchorProps), { open: mode === Mode.Active }));
                default:
                    return react_1.default.cloneElement(label, anchorProps);
            }
        })(),
        open && (react_1.default.createElement(Pane_1.Pane, { ref: childrenRef, zIndex: 1, onEnter: handleClose }, (0, exports.isDropdownRenderProps)(children)
            ? children({ handleClose: handleClose })
            : children))));
};
exports.Dropdown = Dropdown;
exports.Dropdown.displayName = "Dropdown";
var templateObject_1;
//# sourceMappingURL=Dropdown.js.map